(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('FavoritesListController', FavoritesListController);

    FavoritesListController.$inject = ['$scope', '$state', '$uibModalInstance', 'OltService', 'FavoritesService'];

    function FavoritesListController($scope, $state, $uibModalInstance, OltService, FavoritesService) {
        var vm = this;

        vm.favoriteList = [];
        vm.selectedFavorites = [];
        vm.requestRunning = false;

        // Call of service
        vm.requestRunning = true;
        FavoritesService.getFavoritables().then(successGetFavorite).catch(errorGetFavorite);

        vm.close = function () {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function successGetFavorite(data) {
            vm.requestRunning = false;
            vm.favoriteList = data;
        }

        function errorGetFavorite(response) {
            vm.requestRunning = false;
            FavoritesService.errorModalConstructor(response, 'getFavoritables');
            vm.close();
        }

        vm.save = function () {
            vm.selectedFavorites = [];
            vm.favoriteList.forEach(function (item) {
                if (item.userFavorite) {
                    vm.selectedFavorites.push(item.id);
                }
            });
            vm.requestRunning = true;
            FavoritesService.saveFavorites(vm.selectedFavorites).then(successSaveFavorites).catch(errorSaveFavorites);
        }

        function successSaveFavorites(data) {
            vm.requestRunning = false;
            FavoritesService.successModalConstructor('save');
            $scope.$emit('favoritesSaved');
        }

        function errorSaveFavorites(response) {
            vm.requestRunning = false;
            FavoritesService.errorModalConstructor(response, 'save');
        }

    }
})();